import React from 'react';
import mapPinSvg from '../../global/images/pin_2.svg';

const MAP_CONTAINER_ID = 'yamapcontainer';

class Map extends React.Component {
  static defaultProps = {
    zoom: 14
  };

  componentDidMount() {
    const { balloonContent, center, zoom } = this.props;

    this.initializeAPI()
      .then(() => {
        window.ymaps.ready(() => {
          this.map = new window.ymaps.Map(
            MAP_CONTAINER_ID,
            { center, zoom, controls: ['zoomControl'] }
          );

          const placemark = new window.ymaps.Placemark(
            center,
            { balloonContent },
            {
              iconLayout: 'default#image',
              iconImageHref: mapPinSvg,
              iconImageSize: [25, 40],
              iconImageOffset: [-11, -40]
            }
          );
          this.map.geoObjects.add(placemark);

          const fullscreenControl = new window.ymaps.control.FullscreenControl();
          this.map.controls.add(fullscreenControl);
          this.map.behaviors.disable('scrollZoom');

          // разрешаем перетаскивать карту только в фулскрин режиме
          if (/* window.innerWidth < breakpoints.MEDIUM */ true) {
            this.map.behaviors.disable('drag');
            fullscreenControl.events.add('fullscreenenter', () => {
              this.map.behaviors.enable('drag');
            });
            fullscreenControl.events.add('fullscreenexit', () => {
              this.map.behaviors.disable('drag');
            });
          }
        });
      });
  }

  componentWillUnmount() {
    this.map && this.map.destroy();
  }

  initializeAPI = () => new Promise(resolve => {
    if (window.ymaps) {
      resolve();
    } else {
      const script = document.createElement('script');
      script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
      script.type = 'text/javascript';
      script.addEventListener('load', resolve);
      document.head.append(script);
    }
  });

  render() {
    const {
      center,
      zoom,
      balloonContent,
      ...props
    } = this.props;

    return (
      <div id={MAP_CONTAINER_ID} {...props} />
    );
  }
}

export default Map;
